module.exports = __webpack_public_path__ + "img/name.9d3c880c.png";